import React, { useEffect } from 'react';
import './rollback-version.scss';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '../../../components/base/Grid/Grid';
import { dateTimeFormatter, userPositionFormatter } from '../../../utils/formatters';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { getPaginationOpts, responseLogWithNotification } from '../../../utils/utils';
import {
  loadVersionList, loadVersionListClear,
} from '../actions';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { getRollbackVersionData } from '../reducer';
import { TYPE_ROLLBACK_ENUM } from '../../../configs';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export function VersionListDialog(props) {
  const dispatch = useDispatch();
  const {
    id, onClose = () => {}, handleCreateRollbackPlan = () => {}, type = TYPE_ROLLBACK_ENUM.APPLICATION,
  } = props;
  const {
    versionList = [],
    versionListMeta = {},
    loadingVersionList = false,
  } = useSelector(getRollbackVersionData);

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(versionListMeta, opts);
    const requestData = {
      ...paginationOpts,
      id,
      type,
    };
    const p1 = dispatch(loadVersionList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const columns = [
    {
      dataField: 'causer',
      text: 'Исполнитель',
      headerClassName: 'user-column',
      formatter: userPositionFormatter,
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Дата и время изменения',
      headerClassName: 'date-time-column',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'version',
      text: 'Версия',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'action_label',
      text: 'Тип изменения',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'message',
      text: 'Комментарии',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'id',
      text: 'Текущее значение',
      headerClassName: 'module-column',
      formatter: (_, item) => (
        <div
          className="w-100 more-button return-link"
          onClick={() => handleCreateRollbackPlan(item)}
        >
          Откатить
        </div>
      ),
      disableSort: true,
    },
  ];

  useEffect(() => {
    dispatch(loadVersionListClear()).catch(responseLogWithNotification);
    dispatch(loadVersionList({ id, type })).catch(responseLogWithNotification);
  }, []);

  return (
    <Dialog
      className="rollback-version-dialog"
      onClose={onClose}
      open
    >
      <DialogTitle
        header="История изменений"
        title={<Icons onClick={onClose} customIcon icon="close" className="close" />}
      />
      <DialogContent className="rollback-version-dialog-content">
        <TimerLoader loading={loadingVersionList} />
        <div className="rollback-version-dialog-table  custom-scroll-theme sticky-table-wrapper">
          <Grid
            data={versionList}
            columns={columns}
            name="rollback-version-dialog-list"
          />
        </div>
      </DialogContent>
      <DialogFooter>
        <Pagination meta={versionListMeta} list={versionList} handleChangeMeta={loadData} />
      </DialogFooter>
    </Dialog>
  );
}
